<template>
    <div v-if="mode == 'edit'">
        <el-radio v-model="localValue.boolValue" :label="true">{{ $l10n.__('Oui') }}</el-radio>
        <el-radio v-model="localValue.boolValue" :label="false">{{ $l10n.__('Non') }}</el-radio>
    </div>
    <p v-else>
        {{ localValueLabel }}
    </p>
</template>

<script>
import CfMixin from '../../../mixins/CustomfieldInputsMixins';
import { deepEqual } from 'Helpers/deepEqual';

export default {
    mixins: [CfMixin],
    emits: ['update:modelValue'],

    data() {
        return {
            localValue: this.value,
        };
    },

    computed: {
        localValueLabel() {
            if (this.localValue.boolValue !== null) {
                return this.localValue.boolValue === true
                    ? this.$l10n.__('Oui')
                    : this.$l10n.__('Non');
            } else {
                return '';
            }
        },
    },
    watch: {
        localValue(newValue, oldValue) {
            if (!deepEqual(newValue, oldValue)) {
                this.$emit('update:modelValue', newValue);
            }
        },
        value: {
            handler: function (newValue, oldValue) {
                if (!deepEqual(newValue, oldValue)) {
                    this.localValue = newValue;
                }
            },
            deep: true,
        },
    },

    created() {
        if (!this.localValue) {
            this.localValue = JSON.parse(JSON.stringify(this.templateData));
            if (this.prop.defaultValue == '') {
                this.localValue.boolValue = null;
            } else {
                this.localValue.boolValue = this.prop.defaultValue == 'N' ? false : true;
            }
        }
    },
};
</script>
